/** Ejecuta una acción async y muestra el resultado dentro de un modal (FormAlert local). */
export async function runModalClientAction(setModalFeedback, actionPromise) {
  setModalFeedback(null);
  const result = await actionPromise;
  if (result?.message) {
    setModalFeedback({
      type: result.ok ? 'success' : 'error',
      text: result.message,
    });
  }
  return result;
}
